import arrows from '../../../src/assets/images/mo_icon/mo_arrow_left.svg';
import { useNavigate } from 'react-router';
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
    formatDate,
    makeAjax,
    respStatus,
    showMessage,
    url,
} from "../../helpers/global_helper";
import InfiniteScroll from "react-infinite-scroll-component";
import NotificationMoPopup from './InformationMoPopup/NotificationMoPopup';
import { useDispatch } from "react-redux";
import { getUserBalance } from '../../redux/actions';

const NotificationMoDesign = (props) => {
    const dispatch = useDispatch();
    const [isResultPopup, setIsResultPopup] = useState(false);
    const [notificationId, setNotificationId] = useState(null);
    const [notificationSubject, setNotificationSubject] = useState(null);
    const [items, setItems] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const openNotificationResultPopup = (index, notificationId, notificationSubject) => {
        let t = [...items];
        t[index].isNew = 0;
        setItems([...t]);
        setNotificationId(notificationId);
        setNotificationSubject(notificationSubject);
        setIsResultPopup(true);
    };

    const closeNotificationResultPopup = () => {
        setIsResultPopup(false);
    };

    // api for Notification list
    const fetchNotificationData = () => {
        let reqData = {
            page: page,
        };

        makeAjax(url.PLAYER_API.listNotification, reqData, url.PLAYER_MS_EXT).then((response) => {
            if (response.status !== respStatus["SUCCESS"]) {
                showMessage("server error No data find", "error", "error");
                return;
            }
            const newData = response.data.notifResults.data; // Assuming your API returns an array of items
            setItems((prevItems) => [...prevItems, ...newData]);
            setPage((prevPage) => prevPage + 1);
            setHasMore(newData.length > 0);
            dispatch(getUserBalance());
        });
    };

    useEffect(() => {
        fetchNotificationData();
    }, []);

    const Navigate = useNavigate();

    return (
        <div className='mo_notification'>
            <div className='mo_pages_topbar'>
                <div className='back_arrow' onClick={() => Navigate("/")}>
                    <img src={arrows} alt="back arrow" />
                </div>
                <div className='mo_page_heading'>
                    <h2>{props.t("notification")}</h2>
                </div>
            </div>
            <div className="tab_content">
                <div className="table_main">
                    <InfiniteScroll
                        dataLength={items.length}
                        next={() => fetchNotificationData()}
                        pullDownToRefreshThreshold={50}
                        hasMore={hasMore}
                        endMessage={<p className='text-center'>{props.t("data_not_found")}</p>}
                        scrollThreshold={0.8}
                        height={"100vh"}
                    >
                        <table className="table_data">
                            <thead>
                                <tr>
                                    <th>{props.t("no.")}</th>
                                    <th>{props.t("subject")}</th>
                                    <th>{props.t("date")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items &&
                                    items.map((notification, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <div className="notification_row_content">
                                                        <a onClick={() => openNotificationResultPopup(index, notification.id, notification.subject)}
                                                            className={notification.isNew ? "notification-link new" : "notification-link"}
                                                        >
                                                            {notification.subject}

                                                            <span style={{ color: "#00ffdc", fontWeight: "600", textDecoration: "none" }}>{notification.isNew ? "New" : ''}</span>
                                                        </a>

                                                    </div>
                                                </td>
                                                <td style={{ width: "80px" }}>{formatDate(notification.date)}</td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </InfiniteScroll>
                </div>
                {isResultPopup && (
                    <NotificationMoPopup
                        onClose={closeNotificationResultPopup}
                        notificationId={notificationId}
                        notificationSubject={notificationSubject}
                    />
                )}
            </div>
        </div>
    );
};

export default withTranslation()(NotificationMoDesign);
